import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { focusChannel, openChannel, confirm, alertError, openStream, closeTwilioRoom, closeStream } from "actions/ui";
import { sendUserCommand, clearUserCommand } from "actions/commands";

class LifeCycleManagement extends React.Component {

	get TOKEN_COMMAND() {
		return 'getStreamToken';
	}

	get TOKEN_COMMAND_ID() {
		return 'tokenRequest';
	}

	constructor(props) {
		super(props);

		this.state = {
			processingStream: false
		}

		this.handleChannelStreamClose = this.handleChannelStreamClose.bind(this);
		this.openChannelAndRequestForTwilioToken = this.openChannelAndRequestForTwilioToken.bind(this);
		this.getIncomingTwilioVideoStreamConfirmation = this.getIncomingTwilioVideoStreamConfirmation.bind(this);
		this.handleAvatarError = this.handleAvatarError.bind(this);
		this.declineStreamRequest = this.declineStreamRequest.bind(this);
	}

	handleAvatarError(e) {
		e.target.src = this.props.configuration.baseDir + '/gfx/icons/user.png';
	}

	componentDidUpdate(prevProps) {
		const streamRequest = prevProps.streamRequest !== this.props.streamRequest && this.props.streamRequest;
		const tokenFailure = this.props.tokenRequestCommand !== prevProps.tokenRequestCommand && this.props.tokenRequestCommand && this.props.tokenRequestCommand.success === false;
		const tokenSuccess = this.props.tokenRequestCommand !== prevProps.tokenRequestCommand && this.props.tokenRequestCommand && this.props.tokenRequestCommand.success === true;

		if (streamRequest && !this.state.processingStream) {
			this.setState({ processingStream: true, streamRequest: { ...this.props.streamRequest }  }, this.handleIncomingRequest);
		}

		if (tokenSuccess) {
			this.props.openStream(this.state.streamRequest.id, 'stream.video.twilio.room.go', this.props.tokenRequestCommand.result.stream);
			this.props.clearUserCommand(this.TOKEN_COMMAND_ID);
			this.setState({ processingStream: false, streamRequest: undefined  });
		}

		if (tokenFailure) {
			this.props.alertError(this.props.tokenRequestCommand.error);
			this.props.clearUserCommand(this.TOKEN_COMMAND_ID);
			this.setState({ processingStream: false, streamRequest: undefined  });
		}

		// auto-close streams if a corresponding channel is closed:
		if (prevProps.openedChannels !== this.props.openedChannels) {
			this.props.streams
				.filter( stream => stream.channel && prevProps.openedChannels.includes(stream.channel.id) && !this.props.openedChannels.includes(stream.channel.id) )
				.map( this.handleChannelStreamClose );
		}
	}

	handleIncomingRequest() {
		switch (this.state.streamRequest.type) {
			case 'stream.video.twilio.room.go':
				this.handleIncomingTwilioVideoStream();
				break;
			default:
				this.props.alertError('Unsupported stream request: ' + this.state.streamRequest.type);
		}
	}

	getIncomingTwilioVideoStreamConfirmation() {
		const channel = this.state.streamRequest.channel;

		return <div className="wcStreamRequest">
			{channel.avatar && <img src={ channel.avatar } onError={ this.handleAvatarError } className="wcFunctional wcAvatar" alt={channel.name} /> }

			<div className="wcStreamCaller">{ channel.name }</div>
			<div className="wcStreamIncomingText">{ this.props.i18n.incomingVideoStream }</div>
		</div>;
	}

	openChannelAndRequestForTwilioToken() {
		const channel = this.state.streamRequest.channel;

		if (!this.props.openedChannels.includes(channel.id) ) {
			this.props.openChannel(channel.id);
		}
		this.props.focusChannel(channel.id);

		this.props.sendUserCommand(this.TOKEN_COMMAND_ID, this.TOKEN_COMMAND, this.state.streamRequest );
	}

	declineStreamRequest() {
		this.setState({ processingStream: false, streamRequest: undefined  });
	}

	handleIncomingTwilioVideoStream() {
		// TODO: ignore support

		this.props.confirm(this.getIncomingTwilioVideoStreamConfirmation(), undefined, this.declineStreamRequest, [
				{ text: this.props.i18n.videoCallDecline, className: 'wcDeclineButton', callback: this.declineStreamRequest, type: 'link' },
				{ text: this.props.i18n.videoCallAccept, className: 'wcAcceptButton', callback: this.openChannelAndRequestForTwilioToken, type: 'link' }
			], {
				title: this.props.i18n.videoCall,
				timeout: this.props.configuration.interface.streams.video.calls.callingTimeout,
				className: 'wcStreamVideoConfirmation',
				buttonYes: { hidden: true },
				buttonNo: {	hidden: true },
				sound: this.props.configuration.interface.streams.video.calls.incomingSound ? {
					src: this.props.configuration.baseDir + 'assets/sounds/ring01.mp3'
				} : undefined
			}
		);
	}

	handleChannelStreamClose(stream) {
		switch (stream.type) {
			case 'stream.video.twilio.room.go':
				if (this.props.room.name === stream.room ) {
					this.props.room.disconnect();
					this.props.closeTwilioRoom();
				}
				this.props.closeStream(stream.id);
				break;
		}
	}

	render() {
		return null;
	}

}

LifeCycleManagement.propTypes = {
	configuration: PropTypes.object.isRequired
};

export default connect(
	(state) => ({
		i18n: state.application.i18n,
		configuration: state.configuration,
		openedChannels: state.ui.openedChannels,
		streams: state.ui.streams,
		room: state.ui.twilio.room,
		streamRequest: state.ui.streamRequest,
		tokenRequestCommand: state.commands.sent.tokenRequest
	}),
	{ focusChannel, openChannel, confirm, alertError, sendUserCommand, clearUserCommand, openStream, closeTwilioRoom, closeStream }
)(LifeCycleManagement);